import { Button, Grid } from '@mui/material';
import CustomTooltip from 'components/custom-tooltip';
import PlusIcon from 'assets/icons/buttons/plus-circle.svg';
import PlusIconDisabled from 'assets/icons/buttons/plus-circle-disabled.svg';
import { listSelectionStyles } from './styles';

interface IAddPredecessorButton {
  onClick: () => void;
  isDisabled: boolean;
}

export const AddPredecessorButton = ({ isDisabled, onClick }: IAddPredecessorButton) => {
  const Icon = isDisabled ? PlusIconDisabled : PlusIcon;

  return (
    <Grid sx={listSelectionStyles.buttonContainer}>
      <CustomTooltip
        title={isDisabled ? 'There are no available predecessors for this start time.' : undefined}
      >
        <Grid>
          <Button sx={listSelectionStyles.button} disabled={isDisabled} onClick={onClick}>
            <Icon style={listSelectionStyles.buttonIcon} />
            Add
          </Button>
        </Grid>
      </CustomTooltip>
    </Grid>
  );
};
